<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div id="loginContainer" class="text-center">
  <h1>Welcome</h1>
  <p>
    Please enter your login credentials to access the
    {{ applicationName }} Dashboard
  </p>

  <div *ngIf="error" class="alert alert-danger text-left">
    <span class="mr-2">
      <fa-icon [icon]="faExclamationTriangle" size="lg"></fa-icon>
    </span>
    <span class="notification-message">
      <span>{{ error }}</span>
    </span>
  </div>

  <form [formGroup]="loginForm" id="loginForm" (ngSubmit)="login()" novalidate>
    <fieldset class="form-group">
      <input
        id="loginName"
        name="loginName"
        formControlName="loginName"
        type="text"
        required
        placeholder="username"
        class="form-control"
      />
      <div
        class="validationMessage"
        *ngIf="!loginName.valid && (loginName.dirty || loginName.touched)"
      >
        <div class="mt-1">You must enter username</div>
      </div>
    </fieldset>

    <fieldset class="form-group">
      <input
        id="loginPassword"
        formControlName="loginPassword"
        type="password"
        required
        placeholder="password"
        class="form-control"
      />
      <div
        class="validationMessage"
        *ngIf="
          !loginPassword.valid && (loginPassword.dirty || loginPassword.touched)
        "
      >
        <div class="mt-1">You must provide password</div>
      </div>
    </fieldset>

    <div class="form-group">
      <button class="btn btn-primary" id="loginButton" [disabled]="loggingIn">
        <span
          *ngIf="loggingIn"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span *ngIf="!loggingIn" class="oi oi-account-login"></span>
        Login
      </button>
    </div>
  </form>
</div>
